/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import NewPassword from './components/NewPassword'
import {Registration} from './components/Registration'
import {ValidateForgotPassword} from './components/ValidateForgotPassword'
import {ValidateRegistration} from './components/ValidateRegistration'

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('authPage')
    return () => {
      document.body.classList.remove('authPage')
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
      {/* begin::Content */}
      <div className='d-flex justify-content-center align-items-start flex-column pb-lg-20'>
        <div className='container'>
          <Outlet />
        </div>
      </div>
      {/* end::Content */}
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='forgot-password-validation' element={<ValidateForgotPassword />} />
      <Route path='validate-registration' element={<ValidateRegistration />} />

      <Route path='set-new-password' element={<NewPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
